const modals = [...document.querySelectorAll(".popup-panel")];

modals.forEach((item) => {
	item.querySelector(".modal-toggle")?.addEventListener("click", () => {
		closePanel(item);
	});
});

function openPanel(targetPanel, callbackFunction) {
	document.querySelectorAll(".popup-panel.--open").forEach((panel) => {
		closePanel(panel);
	});

	if (!targetPanel.classList.contains("--open")) {
		const bd = document.getElementById("panel-backdrop");
		bd.classList.add("--visible");

		gsap.to(targetPanel, {
			opacity: 1,
			duration: 0.4,
			ease: "power2.out",
			onComplete: () => {
				targetPanel.classList.add("--open");
			},
		});
	}
	lockPageScroll();

	if (callbackFunction) callbackFunction();
}

function closePanel(panel, callbackFunction) {
	const bd = document.getElementById("panel-backdrop");

	gsap.to(panel, {
		opacity: 0,
		duration: 0.3,
		ease: "power2.in",
		onComplete: () => {
			panel.classList.remove("--open");
			bd.classList.remove("--visible");
		},
	});
	unlockPageScroll();

	if (callbackFunction) callbackFunction();
}
